import type { ProjectCommentListResponsePageAllOfThreeContentItem } from './projectCommentListResponsePageAllOfThreeContentItem';

export type ProjectCommentListResponsePageAllOfThree = {
  /** 프로젝트 댓글 목록 */
  content?: ProjectCommentListResponsePageAllOfThreeContentItem[];
};
